import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { PendingActionsRow } from "./PendingActionsRow";
import dashboardStyles from "../dealerDashBoard/dashboardStyles";
import styles from "../dealerDashBoard/DashboardStyles.module.scss";
import PendingActionClient from "../../../shared/clients/PendingActionClient";

const PendingActions = (props) => {
  const [renderApp, setRenderApp] = useState(false);
  const [pendingActions, setPendingActions] = useState([]);

  useEffect(() => {
    const getPendingActions = () => {
      props.hideOrShow(true, true);
      if (props.isNsc) {
        return PendingActionClient.getNscPendingActionsNotifications();
      } else {
        return Promise.resolve({
          pendingActions: props.user.pendingActions,
        });
      }
    };

    getPendingActions()
      .then((data) => {
        setPendingActions(sortByDate(data.pendingActions));
      })
      .catch(() => {
        setPendingActions([]);
      })
      .finally(() => {
        props.hideOrShow(false);
        setRenderApp(true);
      });
  }, []);

  const sortByDate = (pendingActionsArray) => {
    pendingActionsArray.sort(function (a, b) {
      const itemA = new Date(a.dueDate.split("/").reverse());
      const itemB = new Date(b.dueDate.split("/").reverse());

      return itemA - itemB;
    });
    return pendingActionsArray;
  };

  return (
    renderApp && (
      <>
        <div
          style={dashboardStyles.header}
          className={styles.pendingActionsHeader}
        >
          {props.t("DealerDashboard.adminAndPrice")}
          <span data-testid="pendingActionsCount">
            {" "}
            ({pendingActions.length})
          </span>
        </div>
        <Table data-testid="actionsTable" key="actionsTable">
          <PendingActionHeader t={props.t} />
          <TableBody>
            {pendingActions.map((pendingAction, index) => {
              if (
                pendingAction.attributes &&
                pendingAction.attributes["vehicleLines"]
              ) {
                return pendingAction.attributes["vehicleLines"].map(
                  (vehicleLine, vehicleIndex) => {
                    return PendingActionsRow(
                      pendingAction,
                      index + "-" + vehicleIndex,
                      props,
                      vehicleLine
                    );
                  }
                );
              } else {
                return PendingActionsRow(pendingAction, index, props);
              }
            })}
          </TableBody>
        </Table>
      </>
    )
  );
};

const PendingActionHeader = (props) => {
  return (
    <TableHead>
      <TableRow
        style={dashboardStyles.dashboardHeader}
        className={styles.tableHeaderLine}
      >
        <TableCell style={dashboardStyles.typeHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.type")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.orderIdHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.description")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.dateHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.dueDate")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.actionHeader}>
          <div className={styles.alignStart}>
            {props.t("AdminAndPricingDashboard.action")}
          </div>
        </TableCell>
        <TableCell style={dashboardStyles.emptyHeader} />
      </TableRow>
    </TableHead>
  );
};

export default withTranslation("emp")(PendingActions);
